import { useEffect, useState } from 'react';

import * as T from 'prop-types';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@olist/united';

import { bankAccountFormFields } from '../schema';
import { SelectFilterField } from './select-filter-field';

const AccountTypeSelector = ({ bank, onChange }) => {
  const { t } = useTranslation();

  const [lastBank, setLastBank] = useState(bank);

  const chooseABank = [
    {
      value: '--',
      label: t`choose a bank`,
    },
  ];

  useEffect(() => {
    if (bank !== lastBank) {
      setLastBank(bank);
      onChange();
    }
  }, [bank, lastBank, onChange]);

  return bank === lastBank ? (
    <Field
      label={t`account type`}
      name={bankAccountFormFields.ACCOUNT_TYPE}
      options={bank?.accountTypes || chooseABank}
      placeholder={t`choose`}
      render={SelectFilterField}
    />
  ) : (
    <Box height="72px" />
  );
};

const Options = T.shape({
  value: T.string,
  code: T.string,
});

AccountTypeSelector.defaultProps = {
  bank: null,
};

AccountTypeSelector.propTypes = {
  onChange: T.func.isRequired,
  bank: T.shape({ value: T.string, accountTypes: T.arrayOf(Options) }),
};

export { AccountTypeSelector };
